import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import loginService from "../../../services/login.service";
import Cookies from "js-cookie";
import usersService from "@/services/users.service";
import { error } from "console";

// Initial state
const initialState: any = {
  currentUser: null,
  loading: false,
  error: null,
  isAuthenticated: false,
  isAdmin: false,
};

// Async thunk for login
export const getUserById = createAsyncThunk(
  "users/getUserById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await usersService.fetchById(id);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const makeLogin = createAsyncThunk(
  "login/auth",
  async ({ email, password }: any, { rejectWithValue }) => {
    try {
      const response = await loginService.login({ email, password });
      if (response) {
        const { data } = response.data;
        Cookies.set("token", response.data.token, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        if (typeof window !== "undefined") {
          localStorage.setItem("currentUser", JSON.stringify(data));
        }
        return data;
      }
      return "something is happenindg";
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.error || "Invalid username or Password"
      );
    }
  }
);

// Async thunk for signup
export const makeSignup = async ({
  username,
  email,
  phone,
  password,
  referral_code,
}: any) => {
  const formData = { username, email, phone, password, referral_code };
  try {
    const response = await loginService.signup(formData);
    const data = response.data?.message;
    return data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateCurrentUserInfo = async (id: string, data: any) => {
  try {
    const response = await usersService.update(id, data);
    return response.data.message;
  } catch (err) {
    return;
  }
};
export const handleForgetPassword = async (data: any) => {
  try {
    const response = await usersService.forgetPassword(data);
    return response.data.message;
  } catch (err) {
    return;
  }
};
// Async thunk for logout
export const logout = createAsyncThunk(
  "login/logout",
  async (_, { rejectWithValue }) => {
    try {
      if (typeof window !== "undefined") {
        localStorage.removeItem("currentUser");
      }
      Cookies.remove("token");
      return true;
    } catch (error) {
      return rejectWithValue("Failed to logout.");
    }
  }
);
export const getLoggedInUser = createAsyncThunk<any>(
  "users/CurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const user = usersService.getCurrentAuthUser();
      if (user) return JSON.parse(user);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resetUserPassword = async (data: any) => {
  const token = Cookies.get("token");
  try {
    const response = await usersService.resetPassword(data, token);
    Cookies.set("token", response.data.token, {
      expires: 1,
      secure: true,
      sameSite: "Strict",
    });
    return response.data?.message;
  } catch (error) {}
};
export const resetPasswordFromEmail = async (token: string, data: any) => {
  try {
    const response = await usersService.resetFromEmail(token, data);
    return response?.data?.message;
  } catch (error:any) {
    throw new Error(error?.response?.data?.message);
  }
};
export const createContacts = async (data: any) => {
  const token = Cookies.get("token");
  try {
    const response = await usersService.addContacts(data, token);
    Cookies.set("token", response.data.token, {
      expires: 1,
      secure: true,
      sameSite: "Strict",
    });
    return response.data?.message;
  } catch (error) {
    return;
  }
};
export const getAllWhatsapContacts = async () => {
  try {
    const response = await usersService.getAllWhatsapps();
    return response?.data;
  } catch (err) {
    return;
  }
};
export const getAllTelegramContacts = async () => {
  try {
    const response = await usersService.getAllTelegram();
    return response?.data;
  } catch (err) {
    return;
  }
};
export const deleteWhatsappContacts = async (id: string) => {
  try {
    const response = await usersService.deleteWhatsapps(id);
    return response?.data;
  } catch (err) {
    return;
  }
};
export const deleteTelegramContacts = async (id: string) => {
  try {
    const response = await usersService.deleteTelegram(id);
    return response?.data;
  } catch (err) {
    return;
  }
};
export const addTelegramContact = async (data: any) => {
  const token = Cookies.get("token");
  try {
    const response = await usersService.addTelegram(data, token);
    Cookies.set("token", response.data.token, {
      expires: 1,
      secure: true,
      sameSite: "Strict",
    });
    return response.data?.message;
  } catch (error) {
    return;
  }
};
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle login
      .addCase(makeLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload;
        state.isAdmin = action.payload.isAdmin;
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(makeLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.isAdmin = false;
      })

      .addCase(logout.fulfilled, (state) => {
        state.currentUser = null;
        state.loading = false;
        state.error = null;
        state.isAuthenticated = false;
        state.isAdmin = false;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload;
        state.error = null;
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLoggedInUser.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload;
      })
      .addCase(getLoggedInUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
// Selectors
export const selectLoginStatus = (state: any) => state.login.loading;
export const selectCurrentUser = (state: any) => state.login.currentUser;
export const selectLoginError = (state: any) => state.login.error;
export const getIsAuthenticated = (state: any) => state.login.isAuthenticated;
export const getIsAdmin = (state: any) => state.login.isAdmin;

export default loginSlice.reducer;
